import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { MuiPickersUtilsProvider, InlineDatePicker } from 'material-ui-pickers';
import { Button, withStyles, TextField, InputAdornment } from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';
import i18next from 'i18next';
import DateFormatService from '../../WorkplanManager/services/DateFormatService';
import { UkgDateFormat } from '../../WorkplanManager/Enums';

const CssTextField = withStyles({
	root: {
		height: 38,
		width: '100%',
		fontSize: '14px',
		'& .Mui-disabled': {
			backgroundColor: '#f3f3f3'
		},
		'& .MuiOutlinedInput-root': {
			width: '100%',
			height: 38
		},
		'& .MuiOutlinedInput-input': {
			width: '100%',
			height: 38,
			padding: 0
		}
	},
})(TextField);

const styles = theme => ({
	buttonLeft: {
		marginRight: '8px',
		backgroundColor: '#1a518a',
		color: 'white'
	},
	buttonToday: {
		marginRight: '8px',
		backgroundColor: 'white',
		color: '#1a518a',
		border: '1px solid #1a518a'
	},
	calendarButtons: {
		display: 'flex',
		flexDirection: 'column',
		float: 'right',
		marginRight: 8,
		alignItems: 'flex-end'
	},
	buttonRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	maxEndDateLabel: {
		marginBottom: 8,
		color: '#1a518a',
		whiteSpace: 'nowrap',
		textAlign: 'right',
		width: '100%'
	}
});

let customClickBand = false;
let resetClickBand = false;

const MRWorkPlanRolloutItem = (props) => {
	const { label, minDate, maxDate, placeholder, weekStartDay, disableDates, error, disabled, clearable = false } = props;
	const validValue = props.value && moment(props.value, 'YYYY-MM-DD').isValid() ? props.value : null;
	let invalidLabel = props.customButtonLabel !== 'undefined' ? props.customButtonLabel : '';
	let value = validValue === '3000-01-01' ? props.customButtonLabel : DateFormatService.formatDateOrEmpty(validValue, UkgDateFormat.LongDate)
	const ref = useRef(null);

	if (typeof weekStartDay !== 'undefined') {
		moment.updateLocale(i18next.language, {
			week: {
				dow: weekStartDay,
			},
		});
	}

	const selectDateHandler = (date, props) => {
	if (!customClickBand && !resetClickBand)
		props.onChange(props.id, date.format('YYYY-MM-DD'))
	}

	const onOpenHandler = (props) => {
		customClickBand = false
		resetClickBand = false
		if (props.showCustomButton) {
			setTimeout(function () {
				let calendarButtons = document.createElement('div');
				calendarButtons.className = 'CUSTOM__calendarButtons';
				document.getElementById('picker-popover').childNodes[2].appendChild(calendarButtons)
				ReactDOM.render(createButton(props), calendarButtons);
			}, 1);
		}
	}

	const customClick = (props) => {
		customClickBand = true
		ref.current.close();
	}

	const todayClick = (props) => {
		resetClickBand = true
		ref.current.close();
	}

	const createButton = props => {
		return (
			<div className={props.classes.calendarButtons}>
				<span className={props.classes.maxEndDateLabel}>{i18next.t('workplanManager:common.maximumEndDate')}</span>
				<div className={props.classes.buttonRow}>
					<Button variant="contained" onClick={() => todayClick(props)} className={props.classes.buttonToday}>
						{i18next.t('workplanManager:workPlanView.global.reset')}
					</Button>
					<Button variant="contained" onClick={() => customClick(props)} className={props.classes.buttonLeft}>
						{props.customButtonLabel}
					</Button >
				</div>
			</div>
		)
	}

	const closeHandler = (props) => {
		if (customClickBand) {
			let value =  props.customButtonValue ? "3000-01-01" : null
			props.onChange(props.id, value)
		}
		else if (resetClickBand) {
			const resetDate = minDate ? moment(minDate) : moment();
			props.onChange(props.id, resetDate.format('YYYY-MM-DD'));
		}
		customClickBand = false;
		resetClickBand = false;
	}

	return (
		<MuiPickersUtilsProvider utils={MomentUtils}>
			<InlineDatePicker
				ref={ref}
				error={error}
				minDate={minDate}
				maxDate={maxDate}
				disablePast
				invalidDateMessage=''
				TextFieldComponent={
					({ inputProps, onClick, inputRef }) =>
						<CssTextField 
							variant="outlined"
							disabled={disabled}
							placeholder={placeholder}
							value={value}
							onClick={onClick}
							inputRef={inputRef}
							InputProps={{
								inputProps,
								startAdornment: (
									<InputAdornment position="start" disabled={disabled}>
										<FontAwesomeIcon style={{ color: '#6ea0d7' }} icon={faCalendarAlt} />
									</InputAdornment>
								),
							}} />
				}
				onOpen={() => onOpenHandler(props)}
				onlyCalendar
				label={label}
				invalidLabel={invalidLabel}
				format={'YYYY-MM-DD'}
				value={validValue ? moment(validValue, 'YYYY-MM-DD') : null}
				onChange={date => selectDateHandler(date, props)}
				onClose={() => closeHandler(props)}
				shouldDisableDate={(date) => disableDates(date, props)}
				disabled={disabled}
				clearable={clearable}
			// openTo="year"
			// views={views}
			/>
		</MuiPickersUtilsProvider>
	);
}

export default withStyles(styles)(MRWorkPlanRolloutItem);